import compose from 'lodash/fp/compose';
import omit from 'lodash/omit';

import api from '../REST/api';
import {
  replaceNestedWithId,
  replaceNestedWithIds,
} from '../utils/replace-nested-with-id';

export function transformForRendering(contact) {
  return compose([
    cont => replaceNestedWithIds(cont, 'brands'),
    cont => replaceNestedWithId(cont, 'account'),
  ])(contact);
}

export function getTransformedContact(arg) {
  return api
    .getContact(arg)
    .then(response => transformForRendering(response || {}));
}

function getFieldsToRemove(newModel) {
  return [
    'id',
    'account',
    'brands',
    'created',
    'lastModified',
    'createdBy',
    'lastModifiedBy',
  ].concat(newModel ? [] : ['accountId', 'brandIds']);
}

export function transformForPatch(model, newModel = false) {
  return omit(model, getFieldsToRemove(newModel));
}
